/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class WorkRecordServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除工作记录
     * @param ids 主键集合
     * @return OK
     */
    deleteWorkRecord(ids: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteWorkRecord(_response);
        });
    }

    protected processDeleteWorkRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 审核退回工作记录
     * @param backDTO 处理信息
     * @return OK
     */
    backWorkRecord(backDTO: WorkRecordBackDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/back";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(backDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBackWorkRecord(_response);
        });
    }

    protected processBackWorkRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取变更记录
     * @param workRecordId workRecordId
     * @return OK
     */
    getChangeLogList(workRecordId: string): Promise<WorkRecordLogVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/change-log?";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined and cannot be null.");
        else
            url_ += "workRecordId=" + encodeURIComponent("" + workRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetChangeLogList(_response);
        });
    }

    protected processGetChangeLogList(response: AxiosResponse): Promise<WorkRecordLogVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkRecordLogVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkRecordLogVO[]>(<any>null);
    }

    /**
     * 认领工作记录
     * @param workRecordId 工单ID
     * @return OK
     */
    claimWorkRecord(workRecordId: string): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/claim?";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined and cannot be null.");
        else
            url_ += "workRecordId=" + encodeURIComponent("" + workRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClaimWorkRecord(_response);
        });
    }

    protected processClaimWorkRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 追加评论记录
     * @param workRecordCommentsAddDTO workRecordCommentsAddDTO
     * @return OK
     */
    commentsAdd(workRecordCommentsAddDTO: WorkRecordCommentsAddDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/comments/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordCommentsAddDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCommentsAdd(_response);
        });
    }

    protected processCommentsAdd(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取工作记录编辑详情
     * @param workRecordId workRecordId
     * @return OK
     */
    getWorkRecordEditDetail(workRecordId: string): Promise<WorkRecordEditDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/edit-detail/{workRecordId}";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined.");
        url_ = url_.replace("{workRecordId}", encodeURIComponent("" + workRecordId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordEditDetail(_response);
        });
    }

    protected processGetWorkRecordEditDetail(response: AxiosResponse): Promise<WorkRecordEditDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordEditDetailVO.fromJS(resultData200) : new WorkRecordEditDetailVO();
            return result200;
        }
        return Promise.resolve<WorkRecordEditDetailVO>(<any>null);
    }

    /**
     * 导出工作记录
     * @param workRecordExcelSelectDTO workRecordExcelSelectDTO
     * @return OK
     */
    exportWorkRecord(workRecordExcelSelectDTO: WorkRecordExcelSelectDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordExcelSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportWorkRecord(_response);
        });
    }

    protected processExportWorkRecord(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 处理详情
     * @param workRecordId 工单ID
     * @return OK
     */
    getWorkRecordHandleDetail(workRecordId: string): Promise<WorkRecordHandleDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/handle-detail?";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined and cannot be null.");
        else
            url_ += "workRecordId=" + encodeURIComponent("" + workRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordHandleDetail(_response);
        });
    }

    protected processGetWorkRecordHandleDetail(response: AxiosResponse): Promise<WorkRecordHandleDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordHandleDetailVO.fromJS(resultData200) : new WorkRecordHandleDetailVO();
            return result200;
        }
        return Promise.resolve<WorkRecordHandleDetailVO>(<any>null);
    }

    /**
     * 新建工作记录
     * @param workRecordCreateDTO workRecordCreateDTO
     * @return OK
     */
    insert(workRecordCreateDTO: WorkRecordCreateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordCreateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取工作记录列表
     * @param current (optional) 当前页
     * @param queryDTO queryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getWorkRecordList(current: number | null | undefined, queryDTO: WorkRecordQueryDTO, size: number | null | undefined): Promise<IPageOfWorkRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/list?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordList(_response);
        });
    }

    protected processGetWorkRecordList(response: AxiosResponse): Promise<IPageOfWorkRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkRecordVO.fromJS(resultData200) : new IPageOfWorkRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkRecordVO>(<any>null);
    }

    /**
     * 获取工作记录列表
     * @param baseQueryDTO baseQueryDTO
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @return OK
     */
    getWorkRecordListByFuzzySearch(baseQueryDTO: WorkRecordBaseQueryDTO, current: number | null | undefined, size: number | null | undefined): Promise<IPageOfWorkRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/list/fuzzy-search?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(baseQueryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordListByFuzzySearch(_response);
        });
    }

    protected processGetWorkRecordListByFuzzySearch(response: AxiosResponse): Promise<IPageOfWorkRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkRecordVO.fromJS(resultData200) : new IPageOfWorkRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkRecordVO>(<any>null);
    }

    /**
     * 获取工作记录概览
     * @param workRecordId 主键集合
     * @return OK
     */
    getWorkRecordBriefInfo(workRecordId: string): Promise<WorkRecordOverviewVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/overview?";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined and cannot be null.");
        else
            url_ += "workRecordId=" + encodeURIComponent("" + workRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordBriefInfo(_response);
        });
    }

    protected processGetWorkRecordBriefInfo(response: AxiosResponse): Promise<WorkRecordOverviewVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordOverviewVO.fromJS(resultData200) : new WorkRecordOverviewVO();
            return result200;
        }
        return Promise.resolve<WorkRecordOverviewVO>(<any>null);
    }

    /**
     * 处理工作记录
     * @param workRecordProcessDTO 处理信息
     * @return OK
     */
    processWorkRecord(workRecordProcessDTO: WorkRecordProcessDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordProcessDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessWorkRecord(_response);
        });
    }

    protected processProcessWorkRecord(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * 获取处理记录信息
     * @param workRecordId workRecordId
     * @return OK
     */
    getWorkRecordProcessCommentInfo(workRecordId: string): Promise<WorkRecordProcessCommentInfoVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/process-comment-info?";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined and cannot be null.");
        else
            url_ += "workRecordId=" + encodeURIComponent("" + workRecordId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordProcessCommentInfo(_response);
        });
    }

    protected processGetWorkRecordProcessCommentInfo(response: AxiosResponse): Promise<WorkRecordProcessCommentInfoVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordProcessCommentInfoVO.fromJS(resultData200) : new WorkRecordProcessCommentInfoVO();
            return result200;
        }
        return Promise.resolve<WorkRecordProcessCommentInfoVO>(<any>null);
    }

    /**
     * 扫一扫获得工作记录
     * @param queryDTO queryDTO
     * @return OK
     */
    getWorkRecordByWorkStationId(queryDTO: WorkRecordScanDTO): Promise<IPageOfWorkRecordVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/scan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordByWorkStationId(_response);
        });
    }

    protected processGetWorkRecordByWorkStationId(response: AxiosResponse): Promise<IPageOfWorkRecordVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkRecordVO.fromJS(resultData200) : new IPageOfWorkRecordVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkRecordVO>(<any>null);
    }

    /**
     * 修改工作记录
     * @param workRecordUpdateDTO workRecordUpdateDTO
     * @return OK
     */
    update(workRecordUpdateDTO: WorkRecordUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class WorkRecordCustomerServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取工作记录列表
     * @param queryDTO queryDTO
     * @return OK
     */
    getWorkRecordList(queryDTO: WorkRecordCustomerQueryDTO): Promise<IPageOfWorkRecordCustomerVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-customer/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordList(_response);
        });
    }

    protected processGetWorkRecordList(response: AxiosResponse): Promise<IPageOfWorkRecordCustomerVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkRecordCustomerVO.fromJS(resultData200) : new IPageOfWorkRecordCustomerVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkRecordCustomerVO>(<any>null);
    }

    /**
     * 获取各状态工作记录统计值
     * @param queryDTO queryDTO
     * @return OK
     */
    getWorkRecordStatistics(queryDTO: WorkRecordCustomerBaseQueryDTO): Promise<WorkRecordCustomerStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-customer/statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordStatistics(_response);
        });
    }

    protected processGetWorkRecordStatistics(response: AxiosResponse): Promise<WorkRecordCustomerStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordCustomerStatisticsVO.fromJS(resultData200) : new WorkRecordCustomerStatisticsVO();
            return result200;
        }
        return Promise.resolve<WorkRecordCustomerStatisticsVO>(<any>null);
    }
}

export class WorkRecordSettingServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取指派人员
     * @param postCodes (optional) postCodes
     * @param postType (optional) postType
     * @return OK
     */
    getAssignedUsers(postCodes: string | null | undefined, postType: number | null | undefined): Promise<WorkRecordUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-setting/assigned/users?";
        if (postCodes !== undefined)
            url_ += "postCodes=" + encodeURIComponent("" + postCodes) + "&"; 
        if (postType !== undefined)
            url_ += "postType=" + encodeURIComponent("" + postType) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAssignedUsers(_response);
        });
    }

    protected processGetAssignedUsers(response: AxiosResponse): Promise<WorkRecordUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordUserVO.fromJS(resultData200) : new WorkRecordUserVO();
            return result200;
        }
        return Promise.resolve<WorkRecordUserVO>(<any>null);
    }

    /**
     * 获取可审核执行人
     * @param id id
     * @return OK
     */
    getAuditUsers(id: string): Promise<WorkRecordUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-setting/audit/users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAuditUsers(_response);
        });
    }

    protected processGetAuditUsers(response: AxiosResponse): Promise<WorkRecordUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordUserVO.fromJS(resultData200) : new WorkRecordUserVO();
            return result200;
        }
        return Promise.resolve<WorkRecordUserVO>(<any>null);
    }

    /**
     * 获取工作记录设置
     * @return OK
     */
    page(): Promise<WorkRecordSettingDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-setting/detail";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<WorkRecordSettingDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordSettingDTO.fromJS(resultData200) : new WorkRecordSettingDTO();
            return result200;
        }
        return Promise.resolve<WorkRecordSettingDTO>(<any>null);
    }

    /**
     * 获取可处理执行人
     * @param id id
     * @return OK
     */
    getProcessUsers(id: string): Promise<WorkRecordUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-setting/process/users?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessUsers(_response);
        });
    }

    protected processGetProcessUsers(response: AxiosResponse): Promise<WorkRecordUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordUserVO.fromJS(resultData200) : new WorkRecordUserVO();
            return result200;
        }
        return Promise.resolve<WorkRecordUserVO>(<any>null);
    }

    /**
     * 新增或修改工作记录设置
     * @param settingDTO settingDTO
     * @return OK
     */
    submit(settingDTO: WorkRecordSettingDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record-setting/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settingDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class WorkRecordReportServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取工作记录编辑详情
     * @param workRecordId workRecordId
     * @return OK
     */
    getWorkRecordReportEditDetail(workRecordId: string): Promise<WorkRecordReportEditDetailVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/report/edit-detail/{workRecordId}";
        if (workRecordId === undefined || workRecordId === null)
            throw new Error("The parameter 'workRecordId' must be defined.");
        url_ = url_.replace("{workRecordId}", encodeURIComponent("" + workRecordId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordReportEditDetail(_response);
        });
    }

    protected processGetWorkRecordReportEditDetail(response: AxiosResponse): Promise<WorkRecordReportEditDetailVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordReportEditDetailVO.fromJS(resultData200) : new WorkRecordReportEditDetailVO();
            return result200;
        }
        return Promise.resolve<WorkRecordReportEditDetailVO>(<any>null);
    }

    /**
     * 导出工作记录报表
     * @param workRecordReportSelectDTO workRecordReportSelectDTO
     * @return OK
     */
    exportWorkRecordReport(workRecordReportSelectDTO: WorkRecordReportSelectDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/report/export-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordReportSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportWorkRecordReport(_response);
        });
    }

    protected processExportWorkRecordReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 工作记录报表
     * @param current (optional) 当前页
     * @param size (optional) 每页的数量
     * @param workRecordReportSelectDTO workRecordReportSelectDTO
     * @return OK
     */
    page(current: number | null | undefined, size: number | null | undefined, workRecordReportSelectDTO: WorkRecordReportSelectDTO): Promise<IPageOfWorkRecordReportVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/report/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordReportSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<IPageOfWorkRecordReportVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? IPageOfWorkRecordReportVO.fromJS(resultData200) : new IPageOfWorkRecordReportVO();
            return result200;
        }
        return Promise.resolve<IPageOfWorkRecordReportVO>(<any>null);
    }

    /**
     * 更新工作记录报表
     * @param workRecordReportUpdateDTO workRecordReportUpdateDTO
     * @return OK
     */
    update(workRecordReportUpdateDTO: WorkRecordReportUpdateDTO): Promise<boolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/report/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordReportUpdateDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class WorkRecordStatisticsServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 获取各状态工作记录统计值
     * @param workRecordReportSelectDTO workRecordReportSelectDTO
     * @return OK
     */
    getWorkRecordStatistics(workRecordReportSelectDTO: WorkRecordReportSelectDTO): Promise<WorkRecordStatisticsVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordReportSelectDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordStatistics(_response);
        });
    }

    protected processGetWorkRecordStatistics(response: AxiosResponse): Promise<WorkRecordStatisticsVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? WorkRecordStatisticsVO.fromJS(resultData200) : new WorkRecordStatisticsVO();
            return result200;
        }
        return Promise.resolve<WorkRecordStatisticsVO>(<any>null);
    }

    /**
     * 大区工作记录统计值
     * @return OK
     */
    getAreaWorkRecordStatistics(): Promise<AreaWorkRecordStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/area";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAreaWorkRecordStatistics(_response);
        });
    }

    protected processGetAreaWorkRecordStatistics(response: AxiosResponse): Promise<AreaWorkRecordStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaWorkRecordStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AreaWorkRecordStatisticsVO[]>(<any>null);
    }

    /**
     * 获取处理人工作记录统计
     * @param workRecordHandlerDTO workRecordHandlerDTO
     * @return OK
     */
    getHandlerWorkRecordStatistics(workRecordHandlerDTO: WorkRecordHandlerDTO): Promise<WorkRecordHandlerStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/handler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordHandlerDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetHandlerWorkRecordStatistics(_response);
        });
    }

    protected processGetHandlerWorkRecordStatistics(response: AxiosResponse): Promise<WorkRecordHandlerStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkRecordHandlerStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<WorkRecordHandlerStatisticsVO[]>(<any>null);
    }

    /**
     * 导出获取处理人工作记录统计
     * @param workRecordHandlerDTO workRecordHandlerDTO
     * @return OK
     */
    exportHandlerWorkRecordStatistics(workRecordHandlerDTO: WorkRecordHandlerDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/handler-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordHandlerDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportHandlerWorkRecordStatistics(_response);
        });
    }

    protected processExportHandlerWorkRecordStatistics(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 根据行业分类统计工作记录
     * @param workRecordIndustryJobDTO workRecordIndustryJobDTO
     * @return OK
     */
    getIndustryOrJobWorkRecordStatistics(workRecordIndustryJobDTO: WorkRecordIndustryOrJobDTO): Promise<ChartDataVOOflong[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/industry-or-job";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordIndustryJobDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIndustryOrJobWorkRecordStatistics(_response);
        });
    }

    protected processGetIndustryOrJobWorkRecordStatistics(response: AxiosResponse): Promise<ChartDataVOOflong[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVOOflong.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVOOflong[]>(<any>null);
    }

    /**
     * 获取工作记录处理统计
     * @param workRecordReportProcessStatisticsDTO workRecordReportProcessStatisticsDTO
     * @return OK
     */
    getWorkRecordProcessStatistics(workRecordReportProcessStatisticsDTO: WorkRecordReportProcessStatisticsDTO): Promise<ChartDataVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(workRecordReportProcessStatisticsDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetWorkRecordProcessStatistics(_response);
        });
    }

    protected processGetWorkRecordProcessStatistics(response: AxiosResponse): Promise<ChartDataVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChartDataVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ChartDataVO[]>(<any>null);
    }

    /**
     * 省份工作记录统计值
     * @param areaName (optional) areaName
     * @return OK
     */
    getProvinceWorkRecordStatistics(areaName: string | null | undefined): Promise<AreaWorkRecordStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/province?";
        if (areaName !== undefined)
            url_ += "areaName=" + encodeURIComponent("" + areaName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProvinceWorkRecordStatistics(_response);
        });
    }

    protected processGetProvinceWorkRecordStatistics(response: AxiosResponse): Promise<AreaWorkRecordStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaWorkRecordStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<AreaWorkRecordStatisticsVO[]>(<any>null);
    }

    /**
     * 省份未完成工单数量统计
     * @return OK
     */
    getProvinceUnfinishedWorkRecordStatistics(): Promise<ProvinceUnfinishedWorkRecordStatisticsVO[]> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/masterlink-cps-work-record')+ "/work-record/statistics/province-unfinished-work-record";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProvinceUnfinishedWorkRecordStatistics(_response);
        });
    }

    protected processGetProvinceUnfinishedWorkRecordStatistics(response: AxiosResponse): Promise<ProvinceUnfinishedWorkRecordStatisticsVO[]> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceUnfinishedWorkRecordStatisticsVO.fromJS(item));
            }
            return result200;
        }
        return Promise.resolve<ProvinceUnfinishedWorkRecordStatisticsVO[]>(<any>null);
    }
}

export class AreaWorkRecordStatisticsVO implements IAreaWorkRecordStatisticsVO {
    /** 完成数 */
    completedValue!: string | undefined;
    /** 区域名称 */
    name!: string | undefined;
    /** 总数 */
    totalValue!: string | undefined;

    constructor(data?: IAreaWorkRecordStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.completedValue = data["completedValue"];
            this.name = data["name"];
            this.totalValue = data["totalValue"];
        }
    }

    static fromJS(data: any): AreaWorkRecordStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new AreaWorkRecordStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedValue"] = this.completedValue;
        data["name"] = this.name;
        data["totalValue"] = this.totalValue;
        return data; 
    }
}

export interface IAreaWorkRecordStatisticsVO {
    /** 完成数 */
    completedValue: string | undefined;
    /** 区域名称 */
    name: string | undefined;
    /** 总数 */
    totalValue: string | undefined;
}

export class AttachmentDTO implements IAttachmentDTO {
    description!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    url!: string | undefined;

    constructor(data?: IAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.name = data["name"];
            this.type = data["type"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): AttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["name"] = this.name;
        data["type"] = this.type;
        data["url"] = this.url;
        return data; 
    }
}

export interface IAttachmentDTO {
    description: string | undefined;
    name: string | undefined;
    type: string | undefined;
    url: string | undefined;
}

export class ChartDataVO implements IChartDataVO {
    name!: string | undefined;
    value!: any | undefined;

    constructor(data?: IChartDataVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ChartDataVO {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IChartDataVO {
    name: string | undefined;
    value: any | undefined;
}

export class ChartDataVOOflong implements IChartDataVOOflong {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IChartDataVOOflong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): ChartDataVOOflong {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataVOOflong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }
}

export interface IChartDataVOOflong {
    name: string | undefined;
    value: string | undefined;
}

export class CustomerAddressDTO implements ICustomerAddressDTO {
    /** 详细地址 */
    address!: string | undefined;
    /** 大区名称 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 职权域 */
    createDept!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: ICustomerAddressDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.createDept = data["createDept"];
            this.customerId = data["customerId"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerAddressDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["createDept"] = this.createDept;
        data["customerId"] = this.customerId;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerAddressDTO {
    /** 详细地址 */
    address: string | undefined;
    /** 大区名称 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 职权域 */
    createDept: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class CustomerAddressVO implements ICustomerAddressVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 大区名称 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;

    constructor(data?: ICustomerAddressVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.provinceName = data["provinceName"];
        }
    }

    static fromJS(data: any): CustomerAddressVO {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAddressVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["provinceName"] = this.provinceName;
        return data; 
    }
}

export interface ICustomerAddressVO {
    /** 详细地址 */
    address: string | undefined;
    /** 大区名称 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
}

export class IPageOfWorkRecordCustomerVO implements IIPageOfWorkRecordCustomerVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkRecordCustomerVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkRecordCustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkRecordCustomerVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkRecordCustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkRecordCustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkRecordCustomerVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkRecordCustomerVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkRecordReportVO implements IIPageOfWorkRecordReportVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkRecordReportVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkRecordReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkRecordReportVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkRecordReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkRecordReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkRecordReportVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkRecordReportVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfWorkRecordVO implements IIPageOfWorkRecordVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: WorkRecordVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfWorkRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(WorkRecordVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfWorkRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfWorkRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfWorkRecordVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: WorkRecordVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class ProvinceUnfinishedWorkRecordStatisticsVO implements IProvinceUnfinishedWorkRecordStatisticsVO {
    /** 省份名称 */
    name!: string | undefined;
    /** 总数 */
    totalValue!: string | undefined;
    /** 未完成数 */
    unfinishedValue!: string | undefined;

    constructor(data?: IProvinceUnfinishedWorkRecordStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.totalValue = data["totalValue"];
            this.unfinishedValue = data["unfinishedValue"];
        }
    }

    static fromJS(data: any): ProvinceUnfinishedWorkRecordStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceUnfinishedWorkRecordStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["totalValue"] = this.totalValue;
        data["unfinishedValue"] = this.unfinishedValue;
        return data; 
    }
}

export interface IProvinceUnfinishedWorkRecordStatisticsVO {
    /** 省份名称 */
    name: string | undefined;
    /** 总数 */
    totalValue: string | undefined;
    /** 未完成数 */
    unfinishedValue: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

export class User implements IUser {
    account!: string | undefined;
    avatar!: string | undefined;
    birthday!: Date | undefined;
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    deptId!: string | undefined;
    email!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    isMiniReportPerson!: number | undefined;
    name!: string | undefined;
    organizationId!: string | undefined;
    password!: string | undefined;
    phone!: string | undefined;
    postId!: string | undefined;
    realName!: string | undefined;
    roleId!: string | undefined;
    sex!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.avatar = data["avatar"];
            this.birthday = data["birthday"] ? new Date(data["birthday"].toString()) : <any>undefined;
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.email = data["email"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isMiniReportPerson = data["isMiniReportPerson"];
            this.name = data["name"];
            this.organizationId = data["organizationId"];
            this.password = data["password"];
            this.phone = data["phone"];
            this.postId = data["postId"];
            this.realName = data["realName"];
            this.roleId = data["roleId"];
            this.sex = data["sex"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["avatar"] = this.avatar;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["email"] = this.email;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isMiniReportPerson"] = this.isMiniReportPerson;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["postId"] = this.postId;
        data["realName"] = this.realName;
        data["roleId"] = this.roleId;
        data["sex"] = this.sex;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IUser {
    account: string | undefined;
    avatar: string | undefined;
    birthday: Date | undefined;
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    deptId: string | undefined;
    email: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    isMiniReportPerson: number | undefined;
    name: string | undefined;
    organizationId: string | undefined;
    password: string | undefined;
    phone: string | undefined;
    postId: string | undefined;
    realName: string | undefined;
    roleId: string | undefined;
    sex: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class WorkRecordAttachmentDTO implements IWorkRecordAttachmentDTO {
    /** 描述(处理记录id) */
    description!: string | undefined;
    /** 所属任务ID */
    taskId!: string | undefined;
    /** 缩略图 */
    thumb!: string | undefined;
    /** 附件类型 */
    type!: string | undefined;
    /** 链接 */
    url!: string | undefined;

    constructor(data?: IWorkRecordAttachmentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.taskId = data["taskId"];
            this.thumb = data["thumb"];
            this.type = data["type"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): WorkRecordAttachmentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordAttachmentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["taskId"] = this.taskId;
        data["thumb"] = this.thumb;
        data["type"] = this.type;
        data["url"] = this.url;
        return data; 
    }
}

export interface IWorkRecordAttachmentDTO {
    /** 描述(处理记录id) */
    description: string | undefined;
    /** 所属任务ID */
    taskId: string | undefined;
    /** 缩略图 */
    thumb: string | undefined;
    /** 附件类型 */
    type: string | undefined;
    /** 链接 */
    url: string | undefined;
}

export class WorkRecordBackDTO implements IWorkRecordBackDTO {
    /** 回退到的节点ID */
    activityId!: string;
    /** 回退到的节点名称 */
    activityName!: string;
    /** 审核消息 */
    message!: string;
    /** 任务ID */
    taskId!: string;
    /** 所属工作记录 */
    workRecordId!: string;

    constructor(data?: IWorkRecordBackDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityId = data["activityId"];
            this.activityName = data["activityName"];
            this.message = data["message"];
            this.taskId = data["taskId"];
            this.workRecordId = data["workRecordId"];
        }
    }

    static fromJS(data: any): WorkRecordBackDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordBackDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["activityName"] = this.activityName;
        data["message"] = this.message;
        data["taskId"] = this.taskId;
        data["workRecordId"] = this.workRecordId;
        return data; 
    }
}

export interface IWorkRecordBackDTO {
    /** 回退到的节点ID */
    activityId: string;
    /** 回退到的节点名称 */
    activityName: string;
    /** 审核消息 */
    message: string;
    /** 任务ID */
    taskId: string;
    /** 所属工作记录 */
    workRecordId: string;
}

export class WorkRecordBaseQueryDTO implements IWorkRecordBaseQueryDTO {
    /** 关键词模糊查询 */
    keyValue!: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string[] | undefined;

    constructor(data?: IWorkRecordBaseQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyValue = data["keyValue"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkRecordBaseQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordBaseQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        return data; 
    }
}

export interface IWorkRecordBaseQueryDTO {
    /** 关键词模糊查询 */
    keyValue: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string[] | undefined;
}

export class WorkRecordCommentsAddDTO implements IWorkRecordCommentsAddDTO {
    /** 附件 */
    attachmentList!: AttachmentDTO[] | undefined;
    /** 单据号 */
    businessKey!: string;
    /** 处理记录 */
    commentMessage!: string;
    /** 任务ID */
    taskId!: string;
    /** 当前处理用户,自动填充登录用户ID */
    userId!: string | undefined;

    constructor(data?: IWorkRecordCommentsAddDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["attachmentList"] && data["attachmentList"].constructor === Array) {
                this.attachmentList = [] as any;
                for (let item of data["attachmentList"])
                    this.attachmentList!.push(AttachmentDTO.fromJS(item));
            }
            this.businessKey = data["businessKey"];
            this.commentMessage = data["commentMessage"];
            this.taskId = data["taskId"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): WorkRecordCommentsAddDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCommentsAddDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.attachmentList && this.attachmentList.constructor === Array) {
            data["attachmentList"] = [];
            for (let item of this.attachmentList)
                data["attachmentList"].push(item.toJSON());
        }
        data["businessKey"] = this.businessKey;
        data["commentMessage"] = this.commentMessage;
        data["taskId"] = this.taskId;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IWorkRecordCommentsAddDTO {
    /** 附件 */
    attachmentList: AttachmentDTO[] | undefined;
    /** 单据号 */
    businessKey: string;
    /** 处理记录 */
    commentMessage: string;
    /** 任务ID */
    taskId: string;
    /** 当前处理用户,自动填充登录用户ID */
    userId: string | undefined;
}

export class WorkRecordCreateDTO implements IWorkRecordCreateDTO {
    /** 附件 */
    attach!: string | undefined;
    /** 音频 */
    audio!: string | undefined;
    channelType!: number;
    /** 零件需求 */
    componentDesc!: string | undefined;
    /** 联系信息 */
    contactInfo!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户地址 */
    customerAddress!: CustomerAddressDTO | undefined;
    /** 客户id */
    customerId!: string;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 邮箱 */
    email!: string | undefined;
    /** 行业类型 */
    industryType!: number | undefined;
    /** 是否更新客户地址 */
    isUpdateCustomerAddress!: number | undefined;
    /** 是否更新出厂时间 */
    isUpdateDeliveryTime!: number | undefined;
    /** 工作类型 */
    jobType!: number | undefined;
    questionDesc!: string;
    status!: number;
    /** 视频 */
    video!: string | undefined;
    workstationId!: string | undefined;
    /** 微信号 */
    wxAccount!: string | undefined;

    constructor(data?: IWorkRecordCreateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attach = data["attach"];
            this.audio = data["audio"];
            this.channelType = data["channelType"];
            this.componentDesc = data["componentDesc"];
            this.contactInfo = data["contactInfo"];
            this.contactUserName = data["contactUserName"];
            this.customerAddress = data["customerAddress"] ? CustomerAddressDTO.fromJS(data["customerAddress"]) : <any>undefined;
            this.customerId = data["customerId"];
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.email = data["email"];
            this.industryType = data["industryType"];
            this.isUpdateCustomerAddress = data["isUpdateCustomerAddress"];
            this.isUpdateDeliveryTime = data["isUpdateDeliveryTime"];
            this.jobType = data["jobType"];
            this.questionDesc = data["questionDesc"];
            this.status = data["status"];
            this.video = data["video"];
            this.workstationId = data["workstationId"];
            this.wxAccount = data["wxAccount"];
        }
    }

    static fromJS(data: any): WorkRecordCreateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCreateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attach"] = this.attach;
        data["audio"] = this.audio;
        data["channelType"] = this.channelType;
        data["componentDesc"] = this.componentDesc;
        data["contactInfo"] = this.contactInfo;
        data["contactUserName"] = this.contactUserName;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["industryType"] = this.industryType;
        data["isUpdateCustomerAddress"] = this.isUpdateCustomerAddress;
        data["isUpdateDeliveryTime"] = this.isUpdateDeliveryTime;
        data["jobType"] = this.jobType;
        data["questionDesc"] = this.questionDesc;
        data["status"] = this.status;
        data["video"] = this.video;
        data["workstationId"] = this.workstationId;
        data["wxAccount"] = this.wxAccount;
        return data; 
    }
}

export interface IWorkRecordCreateDTO {
    /** 附件 */
    attach: string | undefined;
    /** 音频 */
    audio: string | undefined;
    channelType: number;
    /** 零件需求 */
    componentDesc: string | undefined;
    /** 联系信息 */
    contactInfo: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户地址 */
    customerAddress: CustomerAddressDTO | undefined;
    /** 客户id */
    customerId: string;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 邮箱 */
    email: string | undefined;
    /** 行业类型 */
    industryType: number | undefined;
    /** 是否更新客户地址 */
    isUpdateCustomerAddress: number | undefined;
    /** 是否更新出厂时间 */
    isUpdateDeliveryTime: number | undefined;
    /** 工作类型 */
    jobType: number | undefined;
    questionDesc: string;
    status: number;
    /** 视频 */
    video: string | undefined;
    workstationId: string | undefined;
    /** 微信号 */
    wxAccount: string | undefined;
}

export class WorkRecordCustomerBaseQueryDTO implements IWorkRecordCustomerBaseQueryDTO {
    /** 客户id */
    customerId!: string | undefined;
    /** 手机号 */
    phone!: string | undefined;

    constructor(data?: IWorkRecordCustomerBaseQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.phone = data["phone"];
        }
    }

    static fromJS(data: any): WorkRecordCustomerBaseQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCustomerBaseQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface IWorkRecordCustomerBaseQueryDTO {
    /** 客户id */
    customerId: string | undefined;
    /** 手机号 */
    phone: string | undefined;
}

export class WorkRecordCustomerQueryDTO implements IWorkRecordCustomerQueryDTO {
    /** 客户id */
    customerId!: string | undefined;
    /** 关键词模糊查询 */
    keyValue!: string | undefined;
    /** 手机号 */
    phone!: string | undefined;
    /** 状态筛选集合：待处理，处理中，已完成 */
    processProgress!: string[] | undefined;
    query!: Query | undefined;
    /** 工位id */
    workstationId!: string | undefined;

    constructor(data?: IWorkRecordCustomerQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.keyValue = data["keyValue"];
            this.phone = data["phone"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkRecordCustomerQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCustomerQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["keyValue"] = this.keyValue;
        data["phone"] = this.phone;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkRecordCustomerQueryDTO {
    /** 客户id */
    customerId: string | undefined;
    /** 关键词模糊查询 */
    keyValue: string | undefined;
    /** 手机号 */
    phone: string | undefined;
    /** 状态筛选集合：待处理，处理中，已完成 */
    processProgress: string[] | undefined;
    query: Query | undefined;
    /** 工位id */
    workstationId: string | undefined;
}

export class WorkRecordCustomerStatisticsVO implements IWorkRecordCustomerStatisticsVO {
    /** 已完成 */
    completed!: number | undefined;
    /** 待处理 */
    pending!: number | undefined;
    /** 处理中 */
    processing!: number | undefined;

    constructor(data?: IWorkRecordCustomerStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.completed = data["completed"];
            this.pending = data["pending"];
            this.processing = data["processing"];
        }
    }

    static fromJS(data: any): WorkRecordCustomerStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCustomerStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completed"] = this.completed;
        data["pending"] = this.pending;
        data["processing"] = this.processing;
        return data; 
    }
}

export interface IWorkRecordCustomerStatisticsVO {
    /** 已完成 */
    completed: number | undefined;
    /** 待处理 */
    pending: number | undefined;
    /** 处理中 */
    processing: number | undefined;
}

export class WorkRecordCustomerVO implements IWorkRecordCustomerVO {
    /** 单据号 */
    code!: string | undefined;
    /** 上报人 */
    contactUserName!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    id!: string | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string | undefined;
    /** 问题描述 */
    questionDesc!: string | undefined;
    /** 提交时间 */
    submitTime!: Date | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;
    /** 机床序列号 */
    workstationSerialNo!: string | undefined;

    constructor(data?: IWorkRecordCustomerVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.contactUserName = data["contactUserName"];
            this.customerName = data["customerName"];
            this.id = data["id"];
            this.processProgress = data["processProgress"];
            this.questionDesc = data["questionDesc"];
            this.submitTime = data["submitTime"] ? new Date(data["submitTime"].toString()) : <any>undefined;
            this.workstationName = data["workstationName"];
            this.workstationSerialNo = data["workstationSerialNo"];
        }
    }

    static fromJS(data: any): WorkRecordCustomerVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordCustomerVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["contactUserName"] = this.contactUserName;
        data["customerName"] = this.customerName;
        data["id"] = this.id;
        data["processProgress"] = this.processProgress;
        data["questionDesc"] = this.questionDesc;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : <any>undefined;
        data["workstationName"] = this.workstationName;
        data["workstationSerialNo"] = this.workstationSerialNo;
        return data; 
    }
}

export interface IWorkRecordCustomerVO {
    /** 单据号 */
    code: string | undefined;
    /** 上报人 */
    contactUserName: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    id: string | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string | undefined;
    /** 问题描述 */
    questionDesc: string | undefined;
    /** 提交时间 */
    submitTime: Date | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
    /** 机床序列号 */
    workstationSerialNo: string | undefined;
}

export class WorkRecordDetailVO implements IWorkRecordDetailVO {
    /** 附件地址列表,上传的各种附件url链接 */
    attachList!: string[] | undefined;
    /** 音频 */
    audio!: string | undefined;
    /** 处理人 */
    claimUserName!: string | undefined;
    /** 单据号 */
    code!: string | undefined;
    /** 零件需求 */
    componentDesc!: string | undefined;
    /** 联系方式: 电话号码等 */
    contactInfo!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户地址 */
    customerAddress!: CustomerAddressVO | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 客户是否删除 */
    customerIsDeleted!: number | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 邮箱 */
    email!: string | undefined;
    /** 服务评价 */
    evaluation!: number | undefined;
    /** 处理结束时间 */
    handleEndTime!: Date | undefined;
    /** 处理开始时间 */
    handleStartTime!: Date | undefined;
    /** 处理时长 */
    handleTimeConsuming!: number | undefined;
    /** 迁移处理记录 */
    handlerInfo!: string | undefined;
    /** 行业类型名称 */
    industryTypeName!: string | undefined;
    /** 试加工状态: 1:否 2:是 */
    isTrialWork!: number | undefined;
    /** 工作类型名称 */
    jobTypeName!: string | undefined;
    /** 解决进度 */
    processProgress!: string | undefined;
    /** 客户请求,也叫做问题描述 */
    questionDesc!: string | undefined;
    /** 客户签名 */
    signature!: string | undefined;
    /** 提交时间 */
    submitTime!: Date | undefined;
    /** 提交人 */
    submitUserName!: string | undefined;
    /** 视频 */
    video!: string | undefined;
    workRecordId!: string | undefined;
    /** 机床出厂时间 */
    workstationDeliveryTime!: Date | undefined;
    /** 机床ID */
    workstationId!: string | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;
    /** 机床序列号 */
    workstationSerialNo!: string | undefined;
    /** 微信号 */
    wxAccount!: string | undefined;

    constructor(data?: IWorkRecordDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["attachList"] && data["attachList"].constructor === Array) {
                this.attachList = [] as any;
                for (let item of data["attachList"])
                    this.attachList!.push(item);
            }
            this.audio = data["audio"];
            this.claimUserName = data["claimUserName"];
            this.code = data["code"];
            this.componentDesc = data["componentDesc"];
            this.contactInfo = data["contactInfo"];
            this.contactUserName = data["contactUserName"];
            this.customerAddress = data["customerAddress"] ? CustomerAddressVO.fromJS(data["customerAddress"]) : <any>undefined;
            this.customerId = data["customerId"];
            this.customerIsDeleted = data["customerIsDeleted"];
            this.customerName = data["customerName"];
            this.email = data["email"];
            this.evaluation = data["evaluation"];
            this.handleEndTime = data["handleEndTime"] ? new Date(data["handleEndTime"].toString()) : <any>undefined;
            this.handleStartTime = data["handleStartTime"] ? new Date(data["handleStartTime"].toString()) : <any>undefined;
            this.handleTimeConsuming = data["handleTimeConsuming"];
            this.handlerInfo = data["handlerInfo"];
            this.industryTypeName = data["industryTypeName"];
            this.isTrialWork = data["isTrialWork"];
            this.jobTypeName = data["jobTypeName"];
            this.processProgress = data["processProgress"];
            this.questionDesc = data["questionDesc"];
            this.signature = data["signature"];
            this.submitTime = data["submitTime"] ? new Date(data["submitTime"].toString()) : <any>undefined;
            this.submitUserName = data["submitUserName"];
            this.video = data["video"];
            this.workRecordId = data["workRecordId"];
            this.workstationDeliveryTime = data["workstationDeliveryTime"] ? new Date(data["workstationDeliveryTime"].toString()) : <any>undefined;
            this.workstationId = data["workstationId"];
            this.workstationName = data["workstationName"];
            this.workstationSerialNo = data["workstationSerialNo"];
            this.wxAccount = data["wxAccount"];
        }
    }

    static fromJS(data: any): WorkRecordDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.attachList && this.attachList.constructor === Array) {
            data["attachList"] = [];
            for (let item of this.attachList)
                data["attachList"].push(item);
        }
        data["audio"] = this.audio;
        data["claimUserName"] = this.claimUserName;
        data["code"] = this.code;
        data["componentDesc"] = this.componentDesc;
        data["contactInfo"] = this.contactInfo;
        data["contactUserName"] = this.contactUserName;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerIsDeleted"] = this.customerIsDeleted;
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["evaluation"] = this.evaluation;
        data["handleEndTime"] = this.handleEndTime ? this.handleEndTime.toISOString() : <any>undefined;
        data["handleStartTime"] = this.handleStartTime ? this.handleStartTime.toISOString() : <any>undefined;
        data["handleTimeConsuming"] = this.handleTimeConsuming;
        data["handlerInfo"] = this.handlerInfo;
        data["industryTypeName"] = this.industryTypeName;
        data["isTrialWork"] = this.isTrialWork;
        data["jobTypeName"] = this.jobTypeName;
        data["processProgress"] = this.processProgress;
        data["questionDesc"] = this.questionDesc;
        data["signature"] = this.signature;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : <any>undefined;
        data["submitUserName"] = this.submitUserName;
        data["video"] = this.video;
        data["workRecordId"] = this.workRecordId;
        data["workstationDeliveryTime"] = this.workstationDeliveryTime ? this.workstationDeliveryTime.toISOString() : <any>undefined;
        data["workstationId"] = this.workstationId;
        data["workstationName"] = this.workstationName;
        data["workstationSerialNo"] = this.workstationSerialNo;
        data["wxAccount"] = this.wxAccount;
        return data; 
    }
}

export interface IWorkRecordDetailVO {
    /** 附件地址列表,上传的各种附件url链接 */
    attachList: string[] | undefined;
    /** 音频 */
    audio: string | undefined;
    /** 处理人 */
    claimUserName: string | undefined;
    /** 单据号 */
    code: string | undefined;
    /** 零件需求 */
    componentDesc: string | undefined;
    /** 联系方式: 电话号码等 */
    contactInfo: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户地址 */
    customerAddress: CustomerAddressVO | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 客户是否删除 */
    customerIsDeleted: number | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 邮箱 */
    email: string | undefined;
    /** 服务评价 */
    evaluation: number | undefined;
    /** 处理结束时间 */
    handleEndTime: Date | undefined;
    /** 处理开始时间 */
    handleStartTime: Date | undefined;
    /** 处理时长 */
    handleTimeConsuming: number | undefined;
    /** 迁移处理记录 */
    handlerInfo: string | undefined;
    /** 行业类型名称 */
    industryTypeName: string | undefined;
    /** 试加工状态: 1:否 2:是 */
    isTrialWork: number | undefined;
    /** 工作类型名称 */
    jobTypeName: string | undefined;
    /** 解决进度 */
    processProgress: string | undefined;
    /** 客户请求,也叫做问题描述 */
    questionDesc: string | undefined;
    /** 客户签名 */
    signature: string | undefined;
    /** 提交时间 */
    submitTime: Date | undefined;
    /** 提交人 */
    submitUserName: string | undefined;
    /** 视频 */
    video: string | undefined;
    workRecordId: string | undefined;
    /** 机床出厂时间 */
    workstationDeliveryTime: Date | undefined;
    /** 机床ID */
    workstationId: string | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
    /** 机床序列号 */
    workstationSerialNo: string | undefined;
    /** 微信号 */
    wxAccount: string | undefined;
}

export class WorkRecordEditDetailVO implements IWorkRecordEditDetailVO {
    /** 附件地址列表,上传的各种附件url链接 */
    attachList!: string[] | undefined;
    /** 零件需求 */
    componentDesc!: string | undefined;
    /** 联系信息 */
    contactInfo!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户地址 */
    customerAddress!: CustomerAddressVO | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 邮箱 */
    email!: string | undefined;
    /** 行业类型 */
    industryType!: number | undefined;
    /** 工作类型 */
    jobType!: number | undefined;
    /** 客户请求(问题描述) */
    questionDesc!: string | undefined;
    /** 视频 */
    video!: string | undefined;
    workRecordId!: string | undefined;
    /** 机床出厂时间 */
    workstationDeliveryTime!: Date | undefined;
    /** 微信号 */
    wxAccount!: string | undefined;

    constructor(data?: IWorkRecordEditDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["attachList"] && data["attachList"].constructor === Array) {
                this.attachList = [] as any;
                for (let item of data["attachList"])
                    this.attachList!.push(item);
            }
            this.componentDesc = data["componentDesc"];
            this.contactInfo = data["contactInfo"];
            this.contactUserName = data["contactUserName"];
            this.customerAddress = data["customerAddress"] ? CustomerAddressVO.fromJS(data["customerAddress"]) : <any>undefined;
            this.customerName = data["customerName"];
            this.email = data["email"];
            this.industryType = data["industryType"];
            this.jobType = data["jobType"];
            this.questionDesc = data["questionDesc"];
            this.video = data["video"];
            this.workRecordId = data["workRecordId"];
            this.workstationDeliveryTime = data["workstationDeliveryTime"] ? new Date(data["workstationDeliveryTime"].toString()) : <any>undefined;
            this.wxAccount = data["wxAccount"];
        }
    }

    static fromJS(data: any): WorkRecordEditDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordEditDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.attachList && this.attachList.constructor === Array) {
            data["attachList"] = [];
            for (let item of this.attachList)
                data["attachList"].push(item);
        }
        data["componentDesc"] = this.componentDesc;
        data["contactInfo"] = this.contactInfo;
        data["contactUserName"] = this.contactUserName;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerName"] = this.customerName;
        data["email"] = this.email;
        data["industryType"] = this.industryType;
        data["jobType"] = this.jobType;
        data["questionDesc"] = this.questionDesc;
        data["video"] = this.video;
        data["workRecordId"] = this.workRecordId;
        data["workstationDeliveryTime"] = this.workstationDeliveryTime ? this.workstationDeliveryTime.toISOString() : <any>undefined;
        data["wxAccount"] = this.wxAccount;
        return data; 
    }
}

export interface IWorkRecordEditDetailVO {
    /** 附件地址列表,上传的各种附件url链接 */
    attachList: string[] | undefined;
    /** 零件需求 */
    componentDesc: string | undefined;
    /** 联系信息 */
    contactInfo: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户地址 */
    customerAddress: CustomerAddressVO | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 邮箱 */
    email: string | undefined;
    /** 行业类型 */
    industryType: number | undefined;
    /** 工作类型 */
    jobType: number | undefined;
    /** 客户请求(问题描述) */
    questionDesc: string | undefined;
    /** 视频 */
    video: string | undefined;
    workRecordId: string | undefined;
    /** 机床出厂时间 */
    workstationDeliveryTime: Date | undefined;
    /** 微信号 */
    wxAccount: string | undefined;
}

export class WorkRecordExcelSelectDTO implements IWorkRecordExcelSelectDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 认领人ID */
    claimUser!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 设备类型 */
    deviceTypeIds!: string[] | undefined;
    /** 结束日期 */
    endTime!: Date | undefined;
    /** 所选中的列表数据 */
    idList!: string[] | undefined;
    /** 是否为高级查询 */
    isAdvance!: boolean | undefined;
    /** 是否涉及机型 */
    isInvolvedMachine!: number | undefined;
    /** 关键词模糊查询 */
    keyValue!: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string[] | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 问题描述 */
    questionDesc!: string | undefined;
    /** 开始日期 */
    startTime!: Date | undefined;
    /** 提交人 */
    submitUserId!: string | undefined;
    /** 工位ID(前端根据设备序列号筛选出工位) */
    workstationId!: string | undefined;

    constructor(data?: IWorkRecordExcelSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.claimUser = data["claimUser"];
            this.contactUserName = data["contactUserName"];
            this.customerId = data["customerId"];
            if (data["deviceTypeIds"] && data["deviceTypeIds"].constructor === Array) {
                this.deviceTypeIds = [] as any;
                for (let item of data["deviceTypeIds"])
                    this.deviceTypeIds!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            if (data["idList"] && data["idList"].constructor === Array) {
                this.idList = [] as any;
                for (let item of data["idList"])
                    this.idList!.push(item);
            }
            this.isAdvance = data["isAdvance"];
            this.isInvolvedMachine = data["isInvolvedMachine"];
            this.keyValue = data["keyValue"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
            this.provinceName = data["provinceName"];
            this.questionDesc = data["questionDesc"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.submitUserId = data["submitUserId"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkRecordExcelSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordExcelSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["claimUser"] = this.claimUser;
        data["contactUserName"] = this.contactUserName;
        data["customerId"] = this.customerId;
        if (this.deviceTypeIds && this.deviceTypeIds.constructor === Array) {
            data["deviceTypeIds"] = [];
            for (let item of this.deviceTypeIds)
                data["deviceTypeIds"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        if (this.idList && this.idList.constructor === Array) {
            data["idList"] = [];
            for (let item of this.idList)
                data["idList"].push(item);
        }
        data["isAdvance"] = this.isAdvance;
        data["isInvolvedMachine"] = this.isInvolvedMachine;
        data["keyValue"] = this.keyValue;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        data["provinceName"] = this.provinceName;
        data["questionDesc"] = this.questionDesc;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["submitUserId"] = this.submitUserId;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkRecordExcelSelectDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 认领人ID */
    claimUser: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 设备类型 */
    deviceTypeIds: string[] | undefined;
    /** 结束日期 */
    endTime: Date | undefined;
    /** 所选中的列表数据 */
    idList: string[] | undefined;
    /** 是否为高级查询 */
    isAdvance: boolean | undefined;
    /** 是否涉及机型 */
    isInvolvedMachine: number | undefined;
    /** 关键词模糊查询 */
    keyValue: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string[] | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 问题描述 */
    questionDesc: string | undefined;
    /** 开始日期 */
    startTime: Date | undefined;
    /** 提交人 */
    submitUserId: string | undefined;
    /** 工位ID(前端根据设备序列号筛选出工位) */
    workstationId: string | undefined;
}

export class WorkRecordFlowParameterVO implements IWorkRecordFlowParameterVO {
    /** 当前任务ID */
    currentTaskId!: string | undefined;
    /** 当前用户是否可执行 */
    enableProcess!: boolean | undefined;
    id!: string | undefined;
    /** 是否认领 */
    isClaim!: number | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string | undefined;

    constructor(data?: IWorkRecordFlowParameterVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentTaskId = data["currentTaskId"];
            this.enableProcess = data["enableProcess"];
            this.id = data["id"];
            this.isClaim = data["isClaim"];
            this.processProgress = data["processProgress"];
        }
    }

    static fromJS(data: any): WorkRecordFlowParameterVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordFlowParameterVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentTaskId"] = this.currentTaskId;
        data["enableProcess"] = this.enableProcess;
        data["id"] = this.id;
        data["isClaim"] = this.isClaim;
        data["processProgress"] = this.processProgress;
        return data; 
    }
}

export interface IWorkRecordFlowParameterVO {
    /** 当前任务ID */
    currentTaskId: string | undefined;
    /** 当前用户是否可执行 */
    enableProcess: boolean | undefined;
    id: string | undefined;
    /** 是否认领 */
    isClaim: number | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string | undefined;
}

export class WorkRecordHandleDetailVO implements IWorkRecordHandleDetailVO {
    /** 设备类型ID */
    deviceTypeId!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 行业类型 */
    industryType!: number | undefined;
    /** 工作类型 */
    jobType!: number | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 1:网关设备 2:自定义设备 3:不涉及机型 */
    status!: number | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;

    constructor(data?: IWorkRecordHandleDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.deviceTypeId = data["deviceTypeId"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.industryType = data["industryType"];
            this.jobType = data["jobType"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.status = data["status"];
            this.workstationName = data["workstationName"];
        }
    }

    static fromJS(data: any): WorkRecordHandleDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordHandleDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceTypeId"] = this.deviceTypeId;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["industryType"] = this.industryType;
        data["jobType"] = this.jobType;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["workstationName"] = this.workstationName;
        return data; 
    }
}

export interface IWorkRecordHandleDetailVO {
    /** 设备类型ID */
    deviceTypeId: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 行业类型 */
    industryType: number | undefined;
    /** 工作类型 */
    jobType: number | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 1:网关设备 2:自定义设备 3:不涉及机型 */
    status: number | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
}

export class WorkRecordHandlerDTO implements IWorkRecordHandlerDTO {
    /** 日期 */
    currentDate!: Date | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 职权域 */
    dataScope!: string | undefined;
    /** 行业类型 */
    industryType!: number | undefined;
    /** 工作类型 */
    jobType!: number | undefined;
    /** 所选中的用户数据 */
    userIdList!: string[] | undefined;

    constructor(data?: IWorkRecordHandlerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentDate = data["currentDate"] ? new Date(data["currentDate"].toString()) : <any>undefined;
            this.customerId = data["customerId"];
            this.dataScope = data["dataScope"];
            this.industryType = data["industryType"];
            this.jobType = data["jobType"];
            if (data["userIdList"] && data["userIdList"].constructor === Array) {
                this.userIdList = [] as any;
                for (let item of data["userIdList"])
                    this.userIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): WorkRecordHandlerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordHandlerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentDate"] = this.currentDate ? formatDate(this.currentDate) : <any>undefined;
        data["customerId"] = this.customerId;
        data["dataScope"] = this.dataScope;
        data["industryType"] = this.industryType;
        data["jobType"] = this.jobType;
        if (this.userIdList && this.userIdList.constructor === Array) {
            data["userIdList"] = [];
            for (let item of this.userIdList)
                data["userIdList"].push(item);
        }
        return data; 
    }
}

export interface IWorkRecordHandlerDTO {
    /** 日期 */
    currentDate: Date | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 职权域 */
    dataScope: string | undefined;
    /** 行业类型 */
    industryType: number | undefined;
    /** 工作类型 */
    jobType: number | undefined;
    /** 所选中的用户数据 */
    userIdList: string[] | undefined;
}

export class WorkRecordHandlerStatisticsVO implements IWorkRecordHandlerStatisticsVO {
    /** 耗时 */
    timeConsuming!: number | undefined;
    /** 用户名 */
    userName!: string | undefined;
    /** 工单数 */
    workRecordNumber!: string | undefined;
    /** 工单占比 */
    workRecordProportion!: string | undefined;

    constructor(data?: IWorkRecordHandlerStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.timeConsuming = data["timeConsuming"];
            this.userName = data["userName"];
            this.workRecordNumber = data["workRecordNumber"];
            this.workRecordProportion = data["workRecordProportion"];
        }
    }

    static fromJS(data: any): WorkRecordHandlerStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordHandlerStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeConsuming"] = this.timeConsuming;
        data["userName"] = this.userName;
        data["workRecordNumber"] = this.workRecordNumber;
        data["workRecordProportion"] = this.workRecordProportion;
        return data; 
    }
}

export interface IWorkRecordHandlerStatisticsVO {
    /** 耗时 */
    timeConsuming: number | undefined;
    /** 用户名 */
    userName: string | undefined;
    /** 工单数 */
    workRecordNumber: string | undefined;
    /** 工单占比 */
    workRecordProportion: string | undefined;
}

export class WorkRecordIndustryOrJobDTO implements IWorkRecordIndustryOrJobDTO {
    /** 地理大区名称 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 类别1行业分类，2工作分类 */
    type!: number | undefined;

    constructor(data?: IWorkRecordIndustryOrJobDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.customerId = data["customerId"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.provinceName = data["provinceName"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.type = data["type"];
        }
    }

    static fromJS(data: any): WorkRecordIndustryOrJobDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordIndustryOrJobDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["customerId"] = this.customerId;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["provinceName"] = this.provinceName;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data; 
    }
}

export interface IWorkRecordIndustryOrJobDTO {
    /** 地理大区名称 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 类别1行业分类，2工作分类 */
    type: number | undefined;
}

export class WorkRecordLogVO implements IWorkRecordLogVO {
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    currentContent!: string | undefined;
    previousContent!: string | undefined;

    constructor(data?: IWorkRecordLogVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.currentContent = data["currentContent"];
            this.previousContent = data["previousContent"];
        }
    }

    static fromJS(data: any): WorkRecordLogVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordLogVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["currentContent"] = this.currentContent;
        data["previousContent"] = this.previousContent;
        return data; 
    }
}

export interface IWorkRecordLogVO {
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    currentContent: string | undefined;
    previousContent: string | undefined;
}

export class WorkRecordOverviewVO implements IWorkRecordOverviewVO {
    /** 当前用户是否可追加评论记录 */
    enableAddComments!: boolean | undefined;
    /** 提交基础信息 */
    workRecordDetailVO!: WorkRecordDetailVO | undefined;
    /** 流程参数 */
    workRecordFlowParameterVO!: WorkRecordFlowParameterVO | undefined;
    /** 附件记录信息 */
    workRecordProcessAttachmentList!: WorkRecordAttachmentDTO[] | undefined;
    /** 处理记录信息 */
    workRecordProcessCommentList!: WorkRecordProcessCommentVO[] | undefined;

    constructor(data?: IWorkRecordOverviewVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.enableAddComments = data["enableAddComments"];
            this.workRecordDetailVO = data["workRecordDetailVO"] ? WorkRecordDetailVO.fromJS(data["workRecordDetailVO"]) : <any>undefined;
            this.workRecordFlowParameterVO = data["workRecordFlowParameterVO"] ? WorkRecordFlowParameterVO.fromJS(data["workRecordFlowParameterVO"]) : <any>undefined;
            if (data["workRecordProcessAttachmentList"] && data["workRecordProcessAttachmentList"].constructor === Array) {
                this.workRecordProcessAttachmentList = [] as any;
                for (let item of data["workRecordProcessAttachmentList"])
                    this.workRecordProcessAttachmentList!.push(WorkRecordAttachmentDTO.fromJS(item));
            }
            if (data["workRecordProcessCommentList"] && data["workRecordProcessCommentList"].constructor === Array) {
                this.workRecordProcessCommentList = [] as any;
                for (let item of data["workRecordProcessCommentList"])
                    this.workRecordProcessCommentList!.push(WorkRecordProcessCommentVO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkRecordOverviewVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordOverviewVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableAddComments"] = this.enableAddComments;
        data["workRecordDetailVO"] = this.workRecordDetailVO ? this.workRecordDetailVO.toJSON() : <any>undefined;
        data["workRecordFlowParameterVO"] = this.workRecordFlowParameterVO ? this.workRecordFlowParameterVO.toJSON() : <any>undefined;
        if (this.workRecordProcessAttachmentList && this.workRecordProcessAttachmentList.constructor === Array) {
            data["workRecordProcessAttachmentList"] = [];
            for (let item of this.workRecordProcessAttachmentList)
                data["workRecordProcessAttachmentList"].push(item.toJSON());
        }
        if (this.workRecordProcessCommentList && this.workRecordProcessCommentList.constructor === Array) {
            data["workRecordProcessCommentList"] = [];
            for (let item of this.workRecordProcessCommentList)
                data["workRecordProcessCommentList"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkRecordOverviewVO {
    /** 当前用户是否可追加评论记录 */
    enableAddComments: boolean | undefined;
    /** 提交基础信息 */
    workRecordDetailVO: WorkRecordDetailVO | undefined;
    /** 流程参数 */
    workRecordFlowParameterVO: WorkRecordFlowParameterVO | undefined;
    /** 附件记录信息 */
    workRecordProcessAttachmentList: WorkRecordAttachmentDTO[] | undefined;
    /** 处理记录信息 */
    workRecordProcessCommentList: WorkRecordProcessCommentVO[] | undefined;
}

export class WorkRecordProcessCommentInfoVO implements IWorkRecordProcessCommentInfoVO {
    /** 退回理由 */
    backComment!: string | undefined;

    constructor(data?: IWorkRecordProcessCommentInfoVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.backComment = data["backComment"];
        }
    }

    static fromJS(data: any): WorkRecordProcessCommentInfoVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordProcessCommentInfoVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["backComment"] = this.backComment;
        return data; 
    }
}

export interface IWorkRecordProcessCommentInfoVO {
    /** 退回理由 */
    backComment: string | undefined;
}

export class WorkRecordProcessCommentVO implements IWorkRecordProcessCommentVO {
    /** 处理记录ID */
    id!: string | undefined;
    /** 处理意见 */
    processComment!: string | undefined;
    /** 处理所处步骤 */
    processStepName!: string | undefined;
    /** 处理时间 */
    processTime!: Date | undefined;
    /** 处理人 */
    processUserName!: string | undefined;
    /** 所属任务ID */
    taskId!: string | undefined;

    constructor(data?: IWorkRecordProcessCommentVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.processComment = data["processComment"];
            this.processStepName = data["processStepName"];
            this.processTime = data["processTime"] ? new Date(data["processTime"].toString()) : <any>undefined;
            this.processUserName = data["processUserName"];
            this.taskId = data["taskId"];
        }
    }

    static fromJS(data: any): WorkRecordProcessCommentVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordProcessCommentVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["processComment"] = this.processComment;
        data["processStepName"] = this.processStepName;
        data["processTime"] = this.processTime ? this.processTime.toISOString() : <any>undefined;
        data["processUserName"] = this.processUserName;
        data["taskId"] = this.taskId;
        return data; 
    }
}

export interface IWorkRecordProcessCommentVO {
    /** 处理记录ID */
    id: string | undefined;
    /** 处理意见 */
    processComment: string | undefined;
    /** 处理所处步骤 */
    processStepName: string | undefined;
    /** 处理时间 */
    processTime: Date | undefined;
    /** 处理人 */
    processUserName: string | undefined;
    /** 所属任务ID */
    taskId: string | undefined;
}

export class WorkRecordProcessDTO implements IWorkRecordProcessDTO {
    /** 附件 */
    attachmentList!: AttachmentDTO[] | undefined;
    /** 处理意见 */
    comments!: string | undefined;
    /** 结束时间 */
    endTime!: Date | undefined;
    /** 服务评价 */
    evaluation!: number | undefined;
    /** 行业类型 */
    industryType!: number | undefined;
    /** 工作类型 */
    jobType!: number | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string;
    /** 下一步处理人 */
    processUserIds!: string[];
    /** 客户签名 */
    signature!: string | undefined;
    /** 开始时间 */
    startTime!: Date | undefined;
    /** 任务Id */
    taskId!: string;
    /** 工作耗时 */
    timeConsuming!: number | undefined;
    /** 单据号 */
    workRecordId!: string;

    constructor(data?: IWorkRecordProcessDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.processUserIds = [];
        }
    }

    init(data?: any) {
        if (data) {
            if (data["attachmentList"] && data["attachmentList"].constructor === Array) {
                this.attachmentList = [] as any;
                for (let item of data["attachmentList"])
                    this.attachmentList!.push(AttachmentDTO.fromJS(item));
            }
            this.comments = data["comments"];
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.evaluation = data["evaluation"];
            this.industryType = data["industryType"];
            this.jobType = data["jobType"];
            this.processProgress = data["processProgress"];
            if (data["processUserIds"] && data["processUserIds"].constructor === Array) {
                this.processUserIds = [] as any;
                for (let item of data["processUserIds"])
                    this.processUserIds!.push(item);
            }
            this.signature = data["signature"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.taskId = data["taskId"];
            this.timeConsuming = data["timeConsuming"];
            this.workRecordId = data["workRecordId"];
        }
    }

    static fromJS(data: any): WorkRecordProcessDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordProcessDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.attachmentList && this.attachmentList.constructor === Array) {
            data["attachmentList"] = [];
            for (let item of this.attachmentList)
                data["attachmentList"].push(item.toJSON());
        }
        data["comments"] = this.comments;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["evaluation"] = this.evaluation;
        data["industryType"] = this.industryType;
        data["jobType"] = this.jobType;
        data["processProgress"] = this.processProgress;
        if (this.processUserIds && this.processUserIds.constructor === Array) {
            data["processUserIds"] = [];
            for (let item of this.processUserIds)
                data["processUserIds"].push(item);
        }
        data["signature"] = this.signature;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["taskId"] = this.taskId;
        data["timeConsuming"] = this.timeConsuming;
        data["workRecordId"] = this.workRecordId;
        return data; 
    }
}

export interface IWorkRecordProcessDTO {
    /** 附件 */
    attachmentList: AttachmentDTO[] | undefined;
    /** 处理意见 */
    comments: string | undefined;
    /** 结束时间 */
    endTime: Date | undefined;
    /** 服务评价 */
    evaluation: number | undefined;
    /** 行业类型 */
    industryType: number | undefined;
    /** 工作类型 */
    jobType: number | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string;
    /** 下一步处理人 */
    processUserIds: string[];
    /** 客户签名 */
    signature: string | undefined;
    /** 开始时间 */
    startTime: Date | undefined;
    /** 任务Id */
    taskId: string;
    /** 工作耗时 */
    timeConsuming: number | undefined;
    /** 单据号 */
    workRecordId: string;
}

export class WorkRecordQueryDTO implements IWorkRecordQueryDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 认领人ID */
    claimUser!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 设备类型 */
    deviceTypeIds!: string[] | undefined;
    /** 结束日期 */
    endTime!: Date | undefined;
    /** 是否涉及机型 */
    isInvolvedMachine!: number | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string[] | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 问题描述 */
    questionDesc!: string | undefined;
    /** 开始日期 */
    startTime!: Date | undefined;
    /** 提交人 */
    submitUserId!: string | undefined;
    /** 工位ID */
    workstationId!: string | undefined;

    constructor(data?: IWorkRecordQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.claimUser = data["claimUser"];
            this.contactUserName = data["contactUserName"];
            this.customerId = data["customerId"];
            if (data["deviceTypeIds"] && data["deviceTypeIds"].constructor === Array) {
                this.deviceTypeIds = [] as any;
                for (let item of data["deviceTypeIds"])
                    this.deviceTypeIds!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.isInvolvedMachine = data["isInvolvedMachine"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
            this.provinceName = data["provinceName"];
            this.questionDesc = data["questionDesc"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.submitUserId = data["submitUserId"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkRecordQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["claimUser"] = this.claimUser;
        data["contactUserName"] = this.contactUserName;
        data["customerId"] = this.customerId;
        if (this.deviceTypeIds && this.deviceTypeIds.constructor === Array) {
            data["deviceTypeIds"] = [];
            for (let item of this.deviceTypeIds)
                data["deviceTypeIds"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isInvolvedMachine"] = this.isInvolvedMachine;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        data["provinceName"] = this.provinceName;
        data["questionDesc"] = this.questionDesc;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["submitUserId"] = this.submitUserId;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkRecordQueryDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 认领人ID */
    claimUser: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 设备类型 */
    deviceTypeIds: string[] | undefined;
    /** 结束日期 */
    endTime: Date | undefined;
    /** 是否涉及机型 */
    isInvolvedMachine: number | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string[] | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 问题描述 */
    questionDesc: string | undefined;
    /** 开始日期 */
    startTime: Date | undefined;
    /** 提交人 */
    submitUserId: string | undefined;
    /** 工位ID */
    workstationId: string | undefined;
}

export class WorkRecordReportEditDetailVO implements IWorkRecordReportEditDetailVO {
    /** 客户地址 */
    customerAddress!: CustomerAddressVO | undefined;
    /** 客户名称 */
    customerId!: string | undefined;
    workRecordId!: string | undefined;
    /** 工位ID */
    workstationId!: string | undefined;

    constructor(data?: IWorkRecordReportEditDetailVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerAddress = data["customerAddress"] ? CustomerAddressVO.fromJS(data["customerAddress"]) : <any>undefined;
            this.customerId = data["customerId"];
            this.workRecordId = data["workRecordId"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkRecordReportEditDetailVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordReportEditDetailVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["workRecordId"] = this.workRecordId;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkRecordReportEditDetailVO {
    /** 客户地址 */
    customerAddress: CustomerAddressVO | undefined;
    /** 客户名称 */
    customerId: string | undefined;
    workRecordId: string | undefined;
    /** 工位ID */
    workstationId: string | undefined;
}

export class WorkRecordReportProcessStatisticsDTO implements IWorkRecordReportProcessStatisticsDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 图表类型: 1:设备序列号,2:客户名称,3:处理工程师 */
    chartType!: number | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 认领人ID */
    claimUser!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 设备类型 */
    deviceTypeIds!: string[] | undefined;
    /** 结束日期 */
    endTime!: Date | undefined;
    /** 是否为高级查询 */
    isAdvance!: boolean;
    /** 是否涉及机型 */
    isInvolvedMachine!: number | undefined;
    /** 关键词模糊查询 */
    keyValue!: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string[] | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 问题描述 */
    questionDesc!: string | undefined;
    /** 开始日期 */
    startTime!: Date | undefined;
    /** 提交人 */
    submitUserId!: string | undefined;
    /** 工位ID(前端根据设备序列号筛选出工位) */
    workstationId!: string | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;

    constructor(data?: IWorkRecordReportProcessStatisticsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.chartType = data["chartType"];
            this.cityName = data["cityName"];
            this.claimUser = data["claimUser"];
            this.contactUserName = data["contactUserName"];
            this.customerId = data["customerId"];
            if (data["deviceTypeIds"] && data["deviceTypeIds"].constructor === Array) {
                this.deviceTypeIds = [] as any;
                for (let item of data["deviceTypeIds"])
                    this.deviceTypeIds!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.isAdvance = data["isAdvance"];
            this.isInvolvedMachine = data["isInvolvedMachine"];
            this.keyValue = data["keyValue"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
            this.provinceName = data["provinceName"];
            this.questionDesc = data["questionDesc"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.submitUserId = data["submitUserId"];
            this.workstationId = data["workstationId"];
            this.workstationName = data["workstationName"];
        }
    }

    static fromJS(data: any): WorkRecordReportProcessStatisticsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordReportProcessStatisticsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["chartType"] = this.chartType;
        data["cityName"] = this.cityName;
        data["claimUser"] = this.claimUser;
        data["contactUserName"] = this.contactUserName;
        data["customerId"] = this.customerId;
        if (this.deviceTypeIds && this.deviceTypeIds.constructor === Array) {
            data["deviceTypeIds"] = [];
            for (let item of this.deviceTypeIds)
                data["deviceTypeIds"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isAdvance"] = this.isAdvance;
        data["isInvolvedMachine"] = this.isInvolvedMachine;
        data["keyValue"] = this.keyValue;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        data["provinceName"] = this.provinceName;
        data["questionDesc"] = this.questionDesc;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["submitUserId"] = this.submitUserId;
        data["workstationId"] = this.workstationId;
        data["workstationName"] = this.workstationName;
        return data; 
    }
}

export interface IWorkRecordReportProcessStatisticsDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 图表类型: 1:设备序列号,2:客户名称,3:处理工程师 */
    chartType: number | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 认领人ID */
    claimUser: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 设备类型 */
    deviceTypeIds: string[] | undefined;
    /** 结束日期 */
    endTime: Date | undefined;
    /** 是否为高级查询 */
    isAdvance: boolean;
    /** 是否涉及机型 */
    isInvolvedMachine: number | undefined;
    /** 关键词模糊查询 */
    keyValue: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string[] | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 问题描述 */
    questionDesc: string | undefined;
    /** 开始日期 */
    startTime: Date | undefined;
    /** 提交人 */
    submitUserId: string | undefined;
    /** 工位ID(前端根据设备序列号筛选出工位) */
    workstationId: string | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
}

export class WorkRecordReportSelectDTO implements IWorkRecordReportSelectDTO {
    /** 区域 */
    areaName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 认领人ID */
    claimUser!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户ID */
    customerId!: string | undefined;
    /** 设备类型 */
    deviceTypeIds!: string[] | undefined;
    /** 结束日期 */
    endTime!: Date | undefined;
    /** 是否为高级查询 */
    isAdvance!: boolean;
    /** 是否涉及机型 */
    isInvolvedMachine!: number | undefined;
    /** 关键词模糊查询 */
    keyValue!: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string[] | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 问题描述 */
    questionDesc!: string | undefined;
    /** 开始日期 */
    startTime!: Date | undefined;
    /** 提交人 */
    submitUserId!: string | undefined;
    /** 工位ID(前端根据设备序列号筛选出工位) */
    workstationId!: string | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;

    constructor(data?: IWorkRecordReportSelectDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.areaName = data["areaName"];
            this.cityName = data["cityName"];
            this.claimUser = data["claimUser"];
            this.contactUserName = data["contactUserName"];
            this.customerId = data["customerId"];
            if (data["deviceTypeIds"] && data["deviceTypeIds"].constructor === Array) {
                this.deviceTypeIds = [] as any;
                for (let item of data["deviceTypeIds"])
                    this.deviceTypeIds!.push(item);
            }
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : <any>undefined;
            this.isAdvance = data["isAdvance"];
            this.isInvolvedMachine = data["isInvolvedMachine"];
            this.keyValue = data["keyValue"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
            this.provinceName = data["provinceName"];
            this.questionDesc = data["questionDesc"];
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : <any>undefined;
            this.submitUserId = data["submitUserId"];
            this.workstationId = data["workstationId"];
            this.workstationName = data["workstationName"];
        }
    }

    static fromJS(data: any): WorkRecordReportSelectDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordReportSelectDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["cityName"] = this.cityName;
        data["claimUser"] = this.claimUser;
        data["contactUserName"] = this.contactUserName;
        data["customerId"] = this.customerId;
        if (this.deviceTypeIds && this.deviceTypeIds.constructor === Array) {
            data["deviceTypeIds"] = [];
            for (let item of this.deviceTypeIds)
                data["deviceTypeIds"].push(item);
        }
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isAdvance"] = this.isAdvance;
        data["isInvolvedMachine"] = this.isInvolvedMachine;
        data["keyValue"] = this.keyValue;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        data["provinceName"] = this.provinceName;
        data["questionDesc"] = this.questionDesc;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["submitUserId"] = this.submitUserId;
        data["workstationId"] = this.workstationId;
        data["workstationName"] = this.workstationName;
        return data; 
    }
}

export interface IWorkRecordReportSelectDTO {
    /** 区域 */
    areaName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 认领人ID */
    claimUser: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户ID */
    customerId: string | undefined;
    /** 设备类型 */
    deviceTypeIds: string[] | undefined;
    /** 结束日期 */
    endTime: Date | undefined;
    /** 是否为高级查询 */
    isAdvance: boolean;
    /** 是否涉及机型 */
    isInvolvedMachine: number | undefined;
    /** 关键词模糊查询 */
    keyValue: string | undefined;
    /** 状态筛选集合：1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string[] | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 问题描述 */
    questionDesc: string | undefined;
    /** 开始日期 */
    startTime: Date | undefined;
    /** 提交人 */
    submitUserId: string | undefined;
    /** 工位ID(前端根据设备序列号筛选出工位) */
    workstationId: string | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
}

export class WorkRecordReportUpdateDTO implements IWorkRecordReportUpdateDTO {
    /** 客户id */
    customerId!: string;
    /** 工作记录id */
    workRecordId!: string;
    workstationId!: string;

    constructor(data?: IWorkRecordReportUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.customerId = data["customerId"];
            this.workRecordId = data["workRecordId"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkRecordReportUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordReportUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["workRecordId"] = this.workRecordId;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

export interface IWorkRecordReportUpdateDTO {
    /** 客户id */
    customerId: string;
    /** 工作记录id */
    workRecordId: string;
    workstationId: string;
}

export class WorkRecordReportVO implements IWorkRecordReportVO {
    /** 详细地址 */
    address!: string | undefined;
    /** 大区名称 */
    areaName!: string | undefined;
    /** 附件地址列表,上传的各种附件url链接 */
    attachList!: string[] | undefined;
    /** 审核完成信息 */
    auditedDesc!: string | undefined;
    /** 审核完成时间 */
    auditedTime!: Date | undefined;
    /** 审核人 */
    auditedUserName!: string | undefined;
    /** 市级名称 */
    cityName!: string | undefined;
    /** 工程师姓名 */
    claimUserName!: string | undefined;
    /** 单据号 */
    code!: string | undefined;
    /** 零件需求描述 */
    componentDesc!: string | undefined;
    /** 零件需求 */
    componentRequest!: string | undefined;
    /** 联系方式: 电话号码等 */
    contactInfo!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 请求时间 */
    createRequestTime!: Date | undefined;
    /** 请求人 */
    createRequestUserName!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 设备类型 */
    deviceTypeName!: string | undefined;
    /** 派发描述 */
    distributeDesc!: string | undefined;
    /** 派发时间 */
    distributeTime!: Date | undefined;
    /** 派发人 */
    distributeUserName!: string | undefined;
    /** 邮箱 */
    email!: string | undefined;
    /** 工作结束时间 */
    handleEndTime!: Date | undefined;
    /** 工作开始时间 */
    handleStartTime!: Date | undefined;
    /** 处理时长 */
    handleTimeConsuming!: number | undefined;
    /** 行业分类 */
    industryTypeName!: string | undefined;
    /** 工作分类 */
    jobTypeName!: string | undefined;
    /** 解决进度 */
    processProgress!: string | undefined;
    /** 处理图片列表 */
    processedAttachList!: string[] | undefined;
    /** 处理信息 */
    processedDesc!: string | undefined;
    /** 工单处理完成时间 */
    processedTime!: Date | undefined;
    /** 工单处理开始时间 */
    processingTime!: Date | undefined;
    /** 处理人 */
    processingUserName!: string | undefined;
    /** 省级名称 */
    provinceName!: string | undefined;
    /** 客户请求,也叫做问题描述 */
    questionDesc!: string | undefined;
    /** 提交人 */
    submitUserName!: string | undefined;
    workRecordId!: string | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;
    /** 机床序列号 */
    workstationSerialNo!: string | undefined;
    /** 微信号 */
    wxAccount!: string | undefined;

    constructor(data?: IWorkRecordReportVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"];
            this.areaName = data["areaName"];
            if (data["attachList"] && data["attachList"].constructor === Array) {
                this.attachList = [] as any;
                for (let item of data["attachList"])
                    this.attachList!.push(item);
            }
            this.auditedDesc = data["auditedDesc"];
            this.auditedTime = data["auditedTime"] ? new Date(data["auditedTime"].toString()) : <any>undefined;
            this.auditedUserName = data["auditedUserName"];
            this.cityName = data["cityName"];
            this.claimUserName = data["claimUserName"];
            this.code = data["code"];
            this.componentDesc = data["componentDesc"];
            this.componentRequest = data["componentRequest"];
            this.contactInfo = data["contactInfo"];
            this.contactUserName = data["contactUserName"];
            this.createRequestTime = data["createRequestTime"] ? new Date(data["createRequestTime"].toString()) : <any>undefined;
            this.createRequestUserName = data["createRequestUserName"];
            this.customerName = data["customerName"];
            this.deviceTypeName = data["deviceTypeName"];
            this.distributeDesc = data["distributeDesc"];
            this.distributeTime = data["distributeTime"] ? new Date(data["distributeTime"].toString()) : <any>undefined;
            this.distributeUserName = data["distributeUserName"];
            this.email = data["email"];
            this.handleEndTime = data["handleEndTime"] ? new Date(data["handleEndTime"].toString()) : <any>undefined;
            this.handleStartTime = data["handleStartTime"] ? new Date(data["handleStartTime"].toString()) : <any>undefined;
            this.handleTimeConsuming = data["handleTimeConsuming"];
            this.industryTypeName = data["industryTypeName"];
            this.jobTypeName = data["jobTypeName"];
            this.processProgress = data["processProgress"];
            if (data["processedAttachList"] && data["processedAttachList"].constructor === Array) {
                this.processedAttachList = [] as any;
                for (let item of data["processedAttachList"])
                    this.processedAttachList!.push(item);
            }
            this.processedDesc = data["processedDesc"];
            this.processedTime = data["processedTime"] ? new Date(data["processedTime"].toString()) : <any>undefined;
            this.processingTime = data["processingTime"] ? new Date(data["processingTime"].toString()) : <any>undefined;
            this.processingUserName = data["processingUserName"];
            this.provinceName = data["provinceName"];
            this.questionDesc = data["questionDesc"];
            this.submitUserName = data["submitUserName"];
            this.workRecordId = data["workRecordId"];
            this.workstationName = data["workstationName"];
            this.workstationSerialNo = data["workstationSerialNo"];
            this.wxAccount = data["wxAccount"];
        }
    }

    static fromJS(data: any): WorkRecordReportVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordReportVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["areaName"] = this.areaName;
        if (this.attachList && this.attachList.constructor === Array) {
            data["attachList"] = [];
            for (let item of this.attachList)
                data["attachList"].push(item);
        }
        data["auditedDesc"] = this.auditedDesc;
        data["auditedTime"] = this.auditedTime ? this.auditedTime.toISOString() : <any>undefined;
        data["auditedUserName"] = this.auditedUserName;
        data["cityName"] = this.cityName;
        data["claimUserName"] = this.claimUserName;
        data["code"] = this.code;
        data["componentDesc"] = this.componentDesc;
        data["componentRequest"] = this.componentRequest;
        data["contactInfo"] = this.contactInfo;
        data["contactUserName"] = this.contactUserName;
        data["createRequestTime"] = this.createRequestTime ? this.createRequestTime.toISOString() : <any>undefined;
        data["createRequestUserName"] = this.createRequestUserName;
        data["customerName"] = this.customerName;
        data["deviceTypeName"] = this.deviceTypeName;
        data["distributeDesc"] = this.distributeDesc;
        data["distributeTime"] = this.distributeTime ? this.distributeTime.toISOString() : <any>undefined;
        data["distributeUserName"] = this.distributeUserName;
        data["email"] = this.email;
        data["handleEndTime"] = this.handleEndTime ? this.handleEndTime.toISOString() : <any>undefined;
        data["handleStartTime"] = this.handleStartTime ? this.handleStartTime.toISOString() : <any>undefined;
        data["handleTimeConsuming"] = this.handleTimeConsuming;
        data["industryTypeName"] = this.industryTypeName;
        data["jobTypeName"] = this.jobTypeName;
        data["processProgress"] = this.processProgress;
        if (this.processedAttachList && this.processedAttachList.constructor === Array) {
            data["processedAttachList"] = [];
            for (let item of this.processedAttachList)
                data["processedAttachList"].push(item);
        }
        data["processedDesc"] = this.processedDesc;
        data["processedTime"] = this.processedTime ? this.processedTime.toISOString() : <any>undefined;
        data["processingTime"] = this.processingTime ? this.processingTime.toISOString() : <any>undefined;
        data["processingUserName"] = this.processingUserName;
        data["provinceName"] = this.provinceName;
        data["questionDesc"] = this.questionDesc;
        data["submitUserName"] = this.submitUserName;
        data["workRecordId"] = this.workRecordId;
        data["workstationName"] = this.workstationName;
        data["workstationSerialNo"] = this.workstationSerialNo;
        data["wxAccount"] = this.wxAccount;
        return data; 
    }
}

export interface IWorkRecordReportVO {
    /** 详细地址 */
    address: string | undefined;
    /** 大区名称 */
    areaName: string | undefined;
    /** 附件地址列表,上传的各种附件url链接 */
    attachList: string[] | undefined;
    /** 审核完成信息 */
    auditedDesc: string | undefined;
    /** 审核完成时间 */
    auditedTime: Date | undefined;
    /** 审核人 */
    auditedUserName: string | undefined;
    /** 市级名称 */
    cityName: string | undefined;
    /** 工程师姓名 */
    claimUserName: string | undefined;
    /** 单据号 */
    code: string | undefined;
    /** 零件需求描述 */
    componentDesc: string | undefined;
    /** 零件需求 */
    componentRequest: string | undefined;
    /** 联系方式: 电话号码等 */
    contactInfo: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 请求时间 */
    createRequestTime: Date | undefined;
    /** 请求人 */
    createRequestUserName: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 设备类型 */
    deviceTypeName: string | undefined;
    /** 派发描述 */
    distributeDesc: string | undefined;
    /** 派发时间 */
    distributeTime: Date | undefined;
    /** 派发人 */
    distributeUserName: string | undefined;
    /** 邮箱 */
    email: string | undefined;
    /** 工作结束时间 */
    handleEndTime: Date | undefined;
    /** 工作开始时间 */
    handleStartTime: Date | undefined;
    /** 处理时长 */
    handleTimeConsuming: number | undefined;
    /** 行业分类 */
    industryTypeName: string | undefined;
    /** 工作分类 */
    jobTypeName: string | undefined;
    /** 解决进度 */
    processProgress: string | undefined;
    /** 处理图片列表 */
    processedAttachList: string[] | undefined;
    /** 处理信息 */
    processedDesc: string | undefined;
    /** 工单处理完成时间 */
    processedTime: Date | undefined;
    /** 工单处理开始时间 */
    processingTime: Date | undefined;
    /** 处理人 */
    processingUserName: string | undefined;
    /** 省级名称 */
    provinceName: string | undefined;
    /** 客户请求,也叫做问题描述 */
    questionDesc: string | undefined;
    /** 提交人 */
    submitUserName: string | undefined;
    workRecordId: string | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
    /** 机床序列号 */
    workstationSerialNo: string | undefined;
    /** 微信号 */
    wxAccount: string | undefined;
}

/** 查询条件 */
export class WorkRecordScanDTO implements IWorkRecordScanDTO {
    /** 当前页 */
    current!: number | undefined;
    /** 状态筛选集合：1待派发，2待处理，3待审核 */
    processProgress!: string[] | undefined;
    /** 每页的数量 */
    size!: number | undefined;
    /** 机床ID */
    workstationId!: string | undefined;

    constructor(data?: IWorkRecordScanDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            if (data["processProgress"] && data["processProgress"].constructor === Array) {
                this.processProgress = [] as any;
                for (let item of data["processProgress"])
                    this.processProgress!.push(item);
            }
            this.size = data["size"];
            this.workstationId = data["workstationId"];
        }
    }

    static fromJS(data: any): WorkRecordScanDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordScanDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        if (this.processProgress && this.processProgress.constructor === Array) {
            data["processProgress"] = [];
            for (let item of this.processProgress)
                data["processProgress"].push(item);
        }
        data["size"] = this.size;
        data["workstationId"] = this.workstationId;
        return data; 
    }
}

/** 查询条件 */
export interface IWorkRecordScanDTO {
    /** 当前页 */
    current: number | undefined;
    /** 状态筛选集合：1待派发，2待处理，3待审核 */
    processProgress: string[] | undefined;
    /** 每页的数量 */
    size: number | undefined;
    /** 机床ID */
    workstationId: string | undefined;
}

export class WorkRecordSettingDTO implements IWorkRecordSettingDTO {
    /** 审核执行人岗位 */
    auditPost!: string | undefined;
    /** 审核超时 提醒时间 */
    auditRemindDate!: string | undefined;
    /** 审核超时 提醒时间单位 */
    auditRemindDateUnit!: string | undefined;
    /** 审核执行人 */
    auditUsers!: string[] | undefined;
    /** 派发执行人岗位 */
    distributionPost!: string | undefined;
    /** 派发超时 提醒时间 */
    distributionRemindDate!: string | undefined;
    /** 派发超时 提醒时间单位 */
    distributionRemindDateUnit!: string | undefined;
    /** 派发执行人 */
    distributionUsers!: string[] | undefined;
    id!: string | undefined;
    /** 处理执行人岗位 */
    processPost!: string | undefined;
    /** 处理超时 提醒时间 */
    processRemindDate!: string | undefined;
    /** 处理超时 提醒时间单位 */
    processRemindDateUnit!: string | undefined;
    /** 处理执行人 */
    processUsers!: string[] | undefined;
    /** 派发超时转派 处理岗位 */
    timeOutDistributionPost!: string | undefined;
    /** 派发超时转派 处理时间 */
    timeOutRelayDate!: string | undefined;
    /** 派发超时转派 处理时间单位 */
    timeOutRelayDateUnit!: string | undefined;

    constructor(data?: IWorkRecordSettingDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.auditPost = data["auditPost"];
            this.auditRemindDate = data["auditRemindDate"];
            this.auditRemindDateUnit = data["auditRemindDateUnit"];
            if (data["auditUsers"] && data["auditUsers"].constructor === Array) {
                this.auditUsers = [] as any;
                for (let item of data["auditUsers"])
                    this.auditUsers!.push(item);
            }
            this.distributionPost = data["distributionPost"];
            this.distributionRemindDate = data["distributionRemindDate"];
            this.distributionRemindDateUnit = data["distributionRemindDateUnit"];
            if (data["distributionUsers"] && data["distributionUsers"].constructor === Array) {
                this.distributionUsers = [] as any;
                for (let item of data["distributionUsers"])
                    this.distributionUsers!.push(item);
            }
            this.id = data["id"];
            this.processPost = data["processPost"];
            this.processRemindDate = data["processRemindDate"];
            this.processRemindDateUnit = data["processRemindDateUnit"];
            if (data["processUsers"] && data["processUsers"].constructor === Array) {
                this.processUsers = [] as any;
                for (let item of data["processUsers"])
                    this.processUsers!.push(item);
            }
            this.timeOutDistributionPost = data["timeOutDistributionPost"];
            this.timeOutRelayDate = data["timeOutRelayDate"];
            this.timeOutRelayDateUnit = data["timeOutRelayDateUnit"];
        }
    }

    static fromJS(data: any): WorkRecordSettingDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordSettingDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["auditPost"] = this.auditPost;
        data["auditRemindDate"] = this.auditRemindDate;
        data["auditRemindDateUnit"] = this.auditRemindDateUnit;
        if (this.auditUsers && this.auditUsers.constructor === Array) {
            data["auditUsers"] = [];
            for (let item of this.auditUsers)
                data["auditUsers"].push(item);
        }
        data["distributionPost"] = this.distributionPost;
        data["distributionRemindDate"] = this.distributionRemindDate;
        data["distributionRemindDateUnit"] = this.distributionRemindDateUnit;
        if (this.distributionUsers && this.distributionUsers.constructor === Array) {
            data["distributionUsers"] = [];
            for (let item of this.distributionUsers)
                data["distributionUsers"].push(item);
        }
        data["id"] = this.id;
        data["processPost"] = this.processPost;
        data["processRemindDate"] = this.processRemindDate;
        data["processRemindDateUnit"] = this.processRemindDateUnit;
        if (this.processUsers && this.processUsers.constructor === Array) {
            data["processUsers"] = [];
            for (let item of this.processUsers)
                data["processUsers"].push(item);
        }
        data["timeOutDistributionPost"] = this.timeOutDistributionPost;
        data["timeOutRelayDate"] = this.timeOutRelayDate;
        data["timeOutRelayDateUnit"] = this.timeOutRelayDateUnit;
        return data; 
    }
}

export interface IWorkRecordSettingDTO {
    /** 审核执行人岗位 */
    auditPost: string | undefined;
    /** 审核超时 提醒时间 */
    auditRemindDate: string | undefined;
    /** 审核超时 提醒时间单位 */
    auditRemindDateUnit: string | undefined;
    /** 审核执行人 */
    auditUsers: string[] | undefined;
    /** 派发执行人岗位 */
    distributionPost: string | undefined;
    /** 派发超时 提醒时间 */
    distributionRemindDate: string | undefined;
    /** 派发超时 提醒时间单位 */
    distributionRemindDateUnit: string | undefined;
    /** 派发执行人 */
    distributionUsers: string[] | undefined;
    id: string | undefined;
    /** 处理执行人岗位 */
    processPost: string | undefined;
    /** 处理超时 提醒时间 */
    processRemindDate: string | undefined;
    /** 处理超时 提醒时间单位 */
    processRemindDateUnit: string | undefined;
    /** 处理执行人 */
    processUsers: string[] | undefined;
    /** 派发超时转派 处理岗位 */
    timeOutDistributionPost: string | undefined;
    /** 派发超时转派 处理时间 */
    timeOutRelayDate: string | undefined;
    /** 派发超时转派 处理时间单位 */
    timeOutRelayDateUnit: string | undefined;
}

export class WorkRecordStatisticsVO implements IWorkRecordStatisticsVO {
    /** 全部 */
    all!: string | undefined;
    /** 待审核 */
    audit!: string | undefined;
    /** 已完成 */
    complete!: string | undefined;
    /** 待派发 */
    distribute!: string | undefined;
    /** 待处理 */
    pending!: string | undefined;

    constructor(data?: IWorkRecordStatisticsVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.all = data["all"];
            this.audit = data["audit"];
            this.complete = data["complete"];
            this.distribute = data["distribute"];
            this.pending = data["pending"];
        }
    }

    static fromJS(data: any): WorkRecordStatisticsVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordStatisticsVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["all"] = this.all;
        data["audit"] = this.audit;
        data["complete"] = this.complete;
        data["distribute"] = this.distribute;
        data["pending"] = this.pending;
        return data; 
    }
}

export interface IWorkRecordStatisticsVO {
    /** 全部 */
    all: string | undefined;
    /** 待审核 */
    audit: string | undefined;
    /** 已完成 */
    complete: string | undefined;
    /** 待派发 */
    distribute: string | undefined;
    /** 待处理 */
    pending: string | undefined;
}

export class WorkRecordUpdateDTO implements IWorkRecordUpdateDTO {
    /** 附件 */
    attach!: string | undefined;
    /** 音频 */
    audio!: string | undefined;
    /** 零件需求 */
    componentDesc!: string | undefined;
    /** 联系信息 */
    contactInfo!: string | undefined;
    /** 联系人 */
    contactUserName!: string | undefined;
    /** 客户地址 */
    customerAddress!: CustomerAddressDTO | undefined;
    /** 出厂时间 */
    deliveryTime!: Date | undefined;
    /** 邮箱 */
    email!: string | undefined;
    /** 行业类型 */
    industryType!: number | undefined;
    /** 是否更新客户地址 */
    isUpdateCustomerAddress!: number | undefined;
    /** 是否更新出厂时间 */
    isUpdateDeliveryTime!: number | undefined;
    /** 工作类型 */
    jobType!: number | undefined;
    questionDesc!: string;
    /** 视频 */
    video!: string | undefined;
    /** 工作记录id */
    workRecordId!: string;
    /** 微信号 */
    wxAccount!: string | undefined;

    constructor(data?: IWorkRecordUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.attach = data["attach"];
            this.audio = data["audio"];
            this.componentDesc = data["componentDesc"];
            this.contactInfo = data["contactInfo"];
            this.contactUserName = data["contactUserName"];
            this.customerAddress = data["customerAddress"] ? CustomerAddressDTO.fromJS(data["customerAddress"]) : <any>undefined;
            this.deliveryTime = data["deliveryTime"] ? new Date(data["deliveryTime"].toString()) : <any>undefined;
            this.email = data["email"];
            this.industryType = data["industryType"];
            this.isUpdateCustomerAddress = data["isUpdateCustomerAddress"];
            this.isUpdateDeliveryTime = data["isUpdateDeliveryTime"];
            this.jobType = data["jobType"];
            this.questionDesc = data["questionDesc"];
            this.video = data["video"];
            this.workRecordId = data["workRecordId"];
            this.wxAccount = data["wxAccount"];
        }
    }

    static fromJS(data: any): WorkRecordUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attach"] = this.attach;
        data["audio"] = this.audio;
        data["componentDesc"] = this.componentDesc;
        data["contactInfo"] = this.contactInfo;
        data["contactUserName"] = this.contactUserName;
        data["customerAddress"] = this.customerAddress ? this.customerAddress.toJSON() : <any>undefined;
        data["deliveryTime"] = this.deliveryTime ? this.deliveryTime.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["industryType"] = this.industryType;
        data["isUpdateCustomerAddress"] = this.isUpdateCustomerAddress;
        data["isUpdateDeliveryTime"] = this.isUpdateDeliveryTime;
        data["jobType"] = this.jobType;
        data["questionDesc"] = this.questionDesc;
        data["video"] = this.video;
        data["workRecordId"] = this.workRecordId;
        data["wxAccount"] = this.wxAccount;
        return data; 
    }
}

export interface IWorkRecordUpdateDTO {
    /** 附件 */
    attach: string | undefined;
    /** 音频 */
    audio: string | undefined;
    /** 零件需求 */
    componentDesc: string | undefined;
    /** 联系信息 */
    contactInfo: string | undefined;
    /** 联系人 */
    contactUserName: string | undefined;
    /** 客户地址 */
    customerAddress: CustomerAddressDTO | undefined;
    /** 出厂时间 */
    deliveryTime: Date | undefined;
    /** 邮箱 */
    email: string | undefined;
    /** 行业类型 */
    industryType: number | undefined;
    /** 是否更新客户地址 */
    isUpdateCustomerAddress: number | undefined;
    /** 是否更新出厂时间 */
    isUpdateDeliveryTime: number | undefined;
    /** 工作类型 */
    jobType: number | undefined;
    questionDesc: string;
    /** 视频 */
    video: string | undefined;
    /** 工作记录id */
    workRecordId: string;
    /** 微信号 */
    wxAccount: string | undefined;
}

export class WorkRecordUserVO implements IWorkRecordUserVO {
    assignedUsers!: string[] | undefined;
    users!: User[] | undefined;

    constructor(data?: IWorkRecordUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["assignedUsers"] && data["assignedUsers"].constructor === Array) {
                this.assignedUsers = [] as any;
                for (let item of data["assignedUsers"])
                    this.assignedUsers!.push(item);
            }
            if (data["users"] && data["users"].constructor === Array) {
                this.users = [] as any;
                for (let item of data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkRecordUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.assignedUsers && this.assignedUsers.constructor === Array) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item);
        }
        if (this.users && this.users.constructor === Array) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IWorkRecordUserVO {
    assignedUsers: string[] | undefined;
    users: User[] | undefined;
}

export class WorkRecordVO implements IWorkRecordVO {
    /** 单据号 */
    code!: string | undefined;
    /** 当前所处任务ID */
    currentTaskId!: string | undefined;
    /** 客户名称 */
    customerName!: string | undefined;
    /** 当前用户是否可执行 */
    enableProcess!: boolean | undefined;
    id!: string | undefined;
    /** 是否认领 */
    isClaim!: number | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress!: string | undefined;
    /** 提交时间 */
    submitTime!: Date | undefined;
    /** 处理完成时间 */
    updateTime!: Date | undefined;
    /** 机床名称 */
    workstationName!: string | undefined;
    /** 机床序列号 */
    workstationSerialNo!: string | undefined;

    constructor(data?: IWorkRecordVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.currentTaskId = data["currentTaskId"];
            this.customerName = data["customerName"];
            this.enableProcess = data["enableProcess"];
            this.id = data["id"];
            this.isClaim = data["isClaim"];
            this.processProgress = data["processProgress"];
            this.submitTime = data["submitTime"] ? new Date(data["submitTime"].toString()) : <any>undefined;
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.workstationName = data["workstationName"];
            this.workstationSerialNo = data["workstationSerialNo"];
        }
    }

    static fromJS(data: any): WorkRecordVO {
        data = typeof data === 'object' ? data : {};
        let result = new WorkRecordVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["currentTaskId"] = this.currentTaskId;
        data["customerName"] = this.customerName;
        data["enableProcess"] = this.enableProcess;
        data["id"] = this.id;
        data["isClaim"] = this.isClaim;
        data["processProgress"] = this.processProgress;
        data["submitTime"] = this.submitTime ? this.submitTime.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["workstationName"] = this.workstationName;
        data["workstationSerialNo"] = this.workstationSerialNo;
        return data; 
    }
}

export interface IWorkRecordVO {
    /** 单据号 */
    code: string | undefined;
    /** 当前所处任务ID */
    currentTaskId: string | undefined;
    /** 客户名称 */
    customerName: string | undefined;
    /** 当前用户是否可执行 */
    enableProcess: boolean | undefined;
    id: string | undefined;
    /** 是否认领 */
    isClaim: number | undefined;
    /** 处理进度: 1:待派发 2:待处理 3:待审核 0:已完成 */
    processProgress: string | undefined;
    /** 提交时间 */
    submitTime: Date | undefined;
    /** 处理完成时间 */
    updateTime: Date | undefined;
    /** 机床名称 */
    workstationName: string | undefined;
    /** 机床序列号 */
    workstationSerialNo: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}